import type { As2DlqTaskRecord } from '../types/api';

// The AS2 gateway's retry-task referenceId is the underlying As2Message entity's id — the same
// UUID exposed to the frontend as As2OutboundMessageRecord.messageId and As2InboundMessageRecord.id
// (both trace back to `message.getId()`; see RetryTaskService.create/enqueueNow and
// OutboundMessageResponse.from/InboundMessageStatusResponse.from in apps/as2-gateway). Inbound and
// outbound messages share one As2Message table, so a referenceId match is exact regardless of
// which task type it came from — no separate confirmation is needed.
export function findMatchingAs2DlqTask(tasks: As2DlqTaskRecord[], referenceId: string): As2DlqTaskRecord | undefined {
  return tasks.find((task) => task.referenceId === referenceId);
}
